(function () {
  function initCustomerLoveItProductDrawers() {
    document.querySelectorAll('[data-customer-love-it-drawer-id]').forEach(function (holder) {
      if (holder.dataset.customerLoveItDrawerInit === 'true') return;
      holder.dataset.customerLoveItDrawerInit = 'true';

      var drawerId = holder.dataset.customerLoveItDrawerId;
      var drawerKey = holder.dataset.customerLoveItDrawerKey;
      var drawerEl = document.getElementById(drawerId);

      if (!drawerId || !drawerKey || !drawerEl || typeof theme === 'undefined' || typeof theme.Drawers !== 'function') {
        return;
      }

      var drawer = new theme.Drawers(drawerId, drawerKey);
      var popupBody = drawerEl.querySelector('[data-card-images-popup-body]');
      var popupTitle = drawerEl.querySelector('[data-card-images-popup-title]');
      var addAllButton = drawerEl.querySelector('[data-card-images-popup-add-all]');

      // Capture phase: theme.Drawers.open() calls stopPropagation(), so bubble listeners on document never run.
      document.addEventListener(
        'click',
        function (event) {
          var trigger = event.target.closest('.js-drawer-open-' + drawerKey);
          if (!trigger) return;

          var sourceCard = trigger.closest('.card-images-product-source');
          if (!sourceCard) return;

          var template = sourceCard.querySelector('template[data-card-images-products-template]');
          var dataNode = sourceCard.querySelector('[data-card-images-variants]');

          if (popupBody) {
            if (template && template.content) {
              popupBody.innerHTML = '';
              var clone = template.content.cloneNode(true);
              popupBody.appendChild(clone);
            } else if (template) {
              popupBody.innerHTML = template.innerHTML;
            } else {
              popupBody.innerHTML = '';
            }
          }

          if (dataNode && addAllButton) {
            var variants = dataNode.dataset.cardImagesVariants || '';
            var total = dataNode.dataset.cardImagesTotal || '';
            var title = dataNode.dataset.cardImagesTitle || 'Products';
            addAllButton.dataset.variantIds = variants;
            addAllButton.textContent = total ? 'Shop looket - ' + total : 'Shop all';
            if (popupTitle) popupTitle.textContent = title;
          }
        },
        true
      );

      if (addAllButton) {
        addAllButton.addEventListener('click', function (event) {
          event.preventDefault();
          var variantIds = (addAllButton.dataset.variantIds || '')
            .split(',')
            .map(function (id) {
              return Number(id.trim());
            })
            .filter(function (id) {
              return Number.isInteger(id) && id > 0;
            });

          if (!variantIds.length) return;

          var items = variantIds.map(function (id) {
            return { id: id, quantity: 1 };
          });

          addAllButton.classList.add('btn--loading');
          addAllButton.setAttribute('aria-disabled', 'true');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: items }),
          })
            .then(function (response) {
              return response.json().then(function (result) {
                if (!response.ok || result.status) {
                  throw new Error(result.description || 'Unable to add products to cart.');
                }
                return result;
              });
            })
            .then(function () {
              drawer.close();
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:open'));
            })
            .catch(function (error) {
              alert(error.message || 'Unable to add products to cart.');
            })
            .finally(function () {
              addAllButton.classList.remove('btn--loading');
              addAllButton.removeAttribute('aria-disabled');
            });
        });
      }
    });
  }

  document.addEventListener('page:loaded', initCustomerLoveItProductDrawers);
  document.addEventListener('shopify:section:load', initCustomerLoveItProductDrawers);
  document.addEventListener('DOMContentLoaded', initCustomerLoveItProductDrawers);
})();
